import { Link } from 'react-router-dom';

export default function CTABanner() {
  return (
    <section className="py-14 md:py-24 bg-gradient-to-br from-[#f67f19] to-[#e06e0a] relative overflow-hidden">
      {/* Decorative Elements */}
      <div className="absolute inset-0 opacity-10" style={{ backgroundImage: 'url("data:image/svg+xml,%3Csvg width=\'60\' height=\'60\' viewBox=\'0 0 60 60\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cg fill=\'none\' fill-rule=\'evenodd\'%3E%3Cg fill=\'%23ffffff\' fill-opacity=\'1\'%3E%3Cpath d=\'M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z\'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")' }}></div>
      
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-white mb-4 md:mb-6">
          Need Electrical Work Done?
        </h2>
        <p className="text-base md:text-xl text-white/90 mb-6 md:mb-8 font-semibold">
          Get your free quote today or call us for same-day service
        </p>
        <div className="flex flex-col sm:flex-row gap-3 md:gap-4 justify-center">
          <Link
            to="/contact"
            className="w-full sm:w-auto bg-white text-[#f67f19] px-6 py-3 md:px-8 md:py-4 rounded-full font-black text-base md:text-lg hover:bg-gray-50 transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer shadow-xl flex items-center justify-center gap-2"
          >
            <i className="ri-file-list-3-line text-xl md:text-2xl"></i>
            Get Free Quote
          </Link>
          <a
            href="tel:0416497716"
            className="w-full sm:w-auto bg-[#535669] text-white px-6 py-3 md:px-8 md:py-4 rounded-full font-black text-base md:text-lg hover:bg-[#444557] transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer shadow-xl flex items-center justify-center gap-2"
          >
            <i className="ri-phone-fill text-xl md:text-2xl"></i>
            Call 0416 497 716
          </a>
        </div>
      </div>
    </section>
  );
}